export const DateRange = Object.freeze({
    "empty": "null", //null
    "today": "0", // today
    "yesterday": "1", //yesterday
    "last7Days": "7", //last 7 days
    "last28Days": "28", //last 28 days
    "last3Months": "90", //last 3 months
});

/**
 * 
 * @param {object} dateObj new Date()
 * @returns YY-MM-DD 
 */
export const parseDate = (dateObj) => {
    return dateObj.toISOString().slice(0, 10);
}

/**
 * 
 * @param {string} days 1 , 3, 5, 8
 * @example  substractDate(DateRange.today)
 */
export const substractDate = (days) => {
    let date = new Date();

    date.setDate(date.getDate() - days);

    return parseDate(date);
};